/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_255dc3ea"]'><cube-button outline primary disabled>outline</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_255dc3ea"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_255dc3ea"}
  /** script content **/
  require("./btn-outline-primary-disabled.mpx.js?isComponent&outputPath=components%2Fbtn-outline-primary-disabled255dc3ea%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-outline-primary-disabled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-outline-primary-disabled255dc3ea%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_255dc3ea"],
    ctorType: "component",
    outputPath: "components/btn-outline-primary-disabled255dc3ea/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>